
const herobg1 = require("../assets/images/Cover_Photo1.png");
const herobg2 = require("../assets/images/Cover_Photo2.png");
const herobg3 = require("../assets/images/CP3.png");
const herobg4 = require("../assets/images/CP4.jpg");
const herbal = require("../assets/images/herbal.png");

export {herobg1, herobg2, herobg3,logo,herobg4,herbal};

const logo = require("../assets/logoNI.png");

const feature = {
    feature1: require("../assets/feature1.png"),
    feature2: require("../assets/feature2.png"),
    feature3: require("../assets/feature3.png"),
    // feature4: require("../assets/feature4.png"),
  };
  
export default feature;


const product_categories = {
    category1: require("../assets/product_category_img/PC1Agri.png"),
    category2: require("../assets/product_category_img/PC2Fertilizr.png"),
    category3: require("../assets/product_category_img/PC3Herbal.png"),
    category4: require("../assets/product_category_img/PC4Bagasse.png"),
}
export {product_categories};


// const countries_flags = [
//     { src: require("../assets/in.svg"), alt: "India" },
//     { src: require("../assets/ca.svg"), alt: "Canada" },
//     { src: require("../assets/us.svg"), alt: "USA" },
//     { src: require("../assets/sg.svg"), alt: "Singapore" },
//     { src: require("../assets/gb.svg"), alt: "United Kingdom" },
//     { src: require("../assets/au.svg"), alt: "Australia" },
//     { src: require("../assets/ae.svg"), alt: "UAE" },
//   ];
  
//   export {countries_flags};
  